import React, { useCallback, useEffect, useState } from "react";
import { BASE_URL } from "../../constant/api";
import { Link, useNavigate } from "react-router-dom";
import { useSession } from "../../ApiCalls/useSession";
import { FaRegStar, FaStar } from "react-icons/fa6";
import { FaStarHalfAlt } from "react-icons/fa";
import AddToCartModel from "../Home/AddToCartModel/AddToCartModel";
import axios from "axios";
import { IoHeartOutline, IoHeartSharp } from "react-icons/io5";

function BannerProductCard({ products }) {
    const totalStars = 5;

    useSession();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [quantity, setQuantity] = useState(0);
    const [wishlist, setWishlist] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // Open Modal
    const openModal = useCallback((product) => {
        setSelectedProduct(product);
        setIsModalOpen(true);
    }, []);

    // Close Modal
    const closeModal = useCallback(() => {
        setIsModalOpen(false);
        setSelectedProduct(null);
    }, []);



    useEffect(() => {
        const getWishlist = async () => {
            const token = localStorage.getItem("token");
            const sessionId = localStorage.getItem("sessionid");
            const headers = token
                ? { Authorization: `Token ${token}` }
                : { "Session-Id": sessionId };
            // console.log(headers);

            try {
                const response = await axios.get(`${BASE_URL}/products/wishlist/`, {
                    headers,
                });
                setWishlist(response.data.items.map((item) => item.product_id));
                // console.log(response)
            } catch (error) {
                console.error("Error fetching wishlist:", error);
            }
        };

        getWishlist();
    }, []);

    // Toggle Wishlist
    const toggleWishlist = async (product_id) => {
        try {
            const isWishlisted = wishlist.includes(product_id);
            const token = localStorage.getItem("token");
            const sessionId = localStorage.getItem("sessionid");
            const headers = token
                ? { Authorization: `Token ${token}` }
                : { "Session-Id": sessionId };
            // console.log(headers);

            const res = await axios.post(
                `${BASE_URL}/products/wishlist/`,
                { product_id },
                { headers }
            );

            // console.log(res);

            setWishlist((prev) =>
                isWishlisted
                    ? prev.filter((id) => id !== product_id)
                    : [...prev, product_id]
            );
        } catch (error) {
            console.error("Error toggling wishlist:", error);
        }
    };

    const handleDeleteWishlistItem = async (productId) => {
        const token = localStorage.getItem("token");
        let sessionId = localStorage.getItem("sessionid");

        const headers = token
            ? { Authorization: `Token ${token}` }
            : { "Session-Id": sessionId };

        // console.log(headers);

        try {
            const response = await axios.delete(`${BASE_URL}/products/wishlist/${productId}/`, {
                // data: { product_id: productId },
                headers,
            });

            if (response.data.Status === "1") {
                // Assuming `wishlist` is a state variable
                setWishlist((prev) => prev.filter((id) => id !== productId));
                console.log("Item deleted successfully:", response.data);
            } else {
                console.error("Unexpected response:", response.data);
            }
        } catch (error) {
            console.error(`Error deleting item ${productId}:`, error);
        }
    };

    // Function to render the stars
    const renderStars = (rating) => {
        const filledStars = Math.floor(rating); // Number of full stars
        const hasHalfStar = rating % 1 >= 0.5; // For half stars
        const emptyStars = totalStars - filledStars - (hasHalfStar ? 1 : 0); // Empty stars

        return (
            <>
                {[...Array(filledStars)].map((_, index) => (
                    <FaStar key={`filled-${index}`} className="text-yellow-500 w-5 h-5" />
                ))}
                {hasHalfStar && <FaStarHalfAlt className="text-yellow-500 w-5 h-5" />}
                {[...Array(emptyStars)].map((_, index) => (
                    <FaRegStar key={`empty-${index}`} className="text-gray-400 w-5 h-5" />
                ))}
            </>
        );
    };




    return (
        <div className="space-y-4 p-4">
            {products.map((product, prodIndex) => (
                <div
                    className="flex flex-wrap sm:flex-nowrap items-center border rounded-lg"
                    key={prodIndex}
                >
                    {/* Left Section: Product Image and Details */}
                    <div className="flex w-full sm:w-5/6 items-center gap-4">
                        {/* Product Image */}
                        <div className="w-1/3 sm:w-1/6">
                            <Link to={`/product-details/${product.id}`}>
                                <img
                                    src={
                                        product.product_images?.[0]?.image
                                            ? product.product_images[0].image.startsWith(BASE_URL)
                                                ? product.product_images[0].image
                                                : `${BASE_URL}${product.product_images[0].image}`
                                            : "/images/default-product.png"
                                    }
                                    alt={product.name || "Product"}
                                    className="h-48 p-4 w-full object-contain"
                                    onError={(e) => {
                                        e.target.src = "/images/default-product.png";
                                    }}
                                />
                            </Link>
                        </div>

                        {/* Product Details */}
                        <div className="flex-1 p-2 md:p-0 "> 
                            <div className="flex justify-between items-center w-full sm:w-[75%] my-2">
                                <Link to={`/product-details/${product.id}`}>
                                    <h2 className="text-lg sm:text-xl font-semibold text-gray-800">
                                        {product.name}
                                    </h2>
                                </Link>
                                <span
                                    className="text-red-700 text-2xl cursor-pointer"
                                    onClick={() =>
                                        wishlist.includes(product.id)
                                            ? handleDeleteWishlistItem(product.id) // Call delete function if the product is in the wishlist
                                            : toggleWishlist(product.id) // Call toggle function to add the product to the wishlist
                                    }
                                >
                                    {wishlist.includes(product.id) ? (

                                        <IoHeartSharp /> // Filled heart for items in the wishlist
                                    ) : (
                                        <IoHeartOutline /> // Outline heart for items not in the wishlist
                                    )}
                                </span>
                           </div>
                            <p className="text-sm sm:text-base w-full sm:w-[75%] text-gray-600 mt-1 line-clamp-2">
                                {product.description || "No description available."}
                            </p>
                            <div className="mt-2 flex  justify-between items-start sm:items-center w-full sm:w-[75%]">
                                <p className="text-sm sm:text-xl font-bold">
                                    ₹{product.price?.toLocaleString("en-IN")}
                                </p>
                                <div className="flex items-center justify-center gap-1 text-yellow-500 text-sm sm:text-base">
                                    {renderStars(product.product_rating)}
                                    <p className="text-gray-900 text-sm sm:text-base font-semibold">
                                        {product.product_rating}
                                    </p>
                                </div>
                            </div>
                            <div>
                                <button
                                    className="bg-[#05BF02] w-full sm:w-[75%] mt-3 rounded-lg hover:bg-brand-secondary text-white font-semibold py-2 px"
                                    onClick={() => openModal(product)}
                                >
                                    Add to Cart
                                </button>
                            </div>
                        </div>

                    </div>

                    {/* Right Section: Offer Image */}
                    <div className="w-full sm:w-1/6 h-48 flex justify-end mt-4 sm:mt-0">
                        <img
                            src={
                                product.product_banner_image?.startsWith(BASE_URL)
                                    ? product.product_banner_image
                                    : `${BASE_URL}${product.product_banner_image}`
                            }
                            alt="Offer"
                            className="h-full w-full object-cover"
                            onError={(e) => {
                                e.target.src = "/images/default-product.png";
                            }}
                        />
                    </div>

                    {/* Product Modal */}
                    <AddToCartModel
                        selectedProduct={selectedProduct}
                        isModalOpen={isModalOpen}
                        closeModal={closeModal}
                    />
                </div>
            ))}
        </div>
    );
}

export default BannerProductCard;
